module.exports = __webpack_public_path__ + "img/special_offer.b47e5322.jpg";